import React, { useState, useRef, useEffect } from "react";
import { Bell } from "lucide-react";

function Notifications({ notifications, onNotificationClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Notification Bell Icon */}
      <button onClick={toggleDropdown} className="relative p-2 bg-gray-200 rounded-full">
        <Bell className="w-6 h-6 text-gray-700" />
        {notifications.length > 0 && (
          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
            {notifications.length}
          </span>
        )}
      </button>

      {/* Notification Dropdown */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-80 bg-white shadow-lg rounded-lg py-2 z-50">
          <h3 className="text-gray-800 text-sm font-semibold px-4 pb-2 border-b">Notifications</h3>
          {notifications.length === 0 ? (
            <p className="text-gray-600 px-4 py-2 text-sm">No new notifications</p>
          ) : (
            <ul>
              {notifications.map((notification) => (
                <li
                  key={notification.id}
                  className="px-4 py-2 text-sm hover:bg-gray-100 text-gray-700 cursor-pointer flex justify-between items-center"
                  onClick={() => onNotificationClick(notification.action)}
                >
                  <span>
                    <strong>{notification.type}:</strong> {notification.message}
                  </span>
                  <span className="text-blue-500 text-xs font-semibold">Take Action</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default Notifications;